import React from 'react';
import configureStore from './store/configureStore';
import {Provider} from 'react-redux';
import initialState from './reducers/initialState';
import App from './App';

const store = configureStore(initialState);


function AppContainer() {

  return (
    <Provider store={store}>
      <App />
    </Provider>
  );
}

export default AppContainer;
